<template>
  <div class="userManagement_cxw">
    <div class="userManagement">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
      >
        <el-table-column
          prop="bankSerialNo"
          label="交易流水号"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          label="交易时间"
          width="200"
          align="center"
        >
          <template slot-scope="scope">{{scope.row.transTime|formatTime}}</template>
        </el-table-column>
        <el-table-column
          prop="transName2DictValue"
          label="交易名称"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="transType2DictValue"
          label="交易类型"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          label="交易卡号"
          width="200"
          align="center"
        >
          <template slot-scope="scope">{{scope.row.transCard|hideLast}}</template>
        </el-table-column>
        <el-table-column
          prop="prdType2dictValue"
          label="产品类型"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="typeof scope.row.prdType2dictValue == 'undefined'">-</span>
            <span v-else>{{scope.row.prdType2dictValue}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="prdCode"
          label="产品代码"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="typeof scope.row.prdCode == 'undefined'">-</span>
            <span v-else>{{scope.row.prdCode}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="prdName"
          label="产品名称"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="typeof scope.row.prdName == 'undefined'">-</span>
            <span v-else>{{scope.row.prdName}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="score"
          label="分数"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="typeof scope.row.score == 'undefined'">-</span>
            <span v-else>{{scope.row.score}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="transShare"
          label="交易份额"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="typeof scope.row.transShare == 'undefined'">-</span>
            <span v-else>{{scope.row.transShare|formatCurrency}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="交易金额(元)"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="typeof scope.row.transMoney == 'undefined'">-</span>
            <span v-else>{{scope.row.transMoney|formatCurrency}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="transState2DictValue"
          label="交易状态"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="feature-container">
              <!-- str.search("c") -->
              <!-- v-if="scope.row.transState=='1'" -->
              <span
                v-if="scope.row.transState=='1'&&functionList.indexOf('331949584632483840')!='-1'"
                class="button--blue"
                @click="getVoucher(scope)"
              >打印凭证</span>
              <span
                v-else-if="scope.row.transState=='3'&&functionList.includes('331949584632483840')"
                class="button--blue"
                @click="getVoucher(scope)"
              >打印凭证</span>
              <span
                v-else-if="functionList.indexOf('331949584632483840')!='-1'"
                style="color:#B3B3B3"
              >打印凭证</span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <yh-pagination
        :page.sync="currentPage"
        :total="sumCount"
      />
    </div>
  </div>
</template>
<script>
import { getFunctionList, pageCount } from '@/mixins';

let stadt;
let enddt;
let strname;

export default {
  name: 'OnSiteServiceDetail',
  mixins: [getFunctionList, pageCount],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      sumCount: 0,
      tableData: [],
      // 功能集合
      functionList: [],
      currentOrgnName: '',
      currentOrgnCode: '',
      showblVideo: true,
      showblip: '',
      voucher: '',
      serviceNum: '', // 全局服务号变量
      session_sn: '',
    };
  },
  watch: {
    currentPage: {
      immediate: false,
      handler() {
        // 后台无返回时，currentPage 会被置为 null
        this.serviceNum = this.$route.query.serviceNo;

        this.getTableData();
      },
    },
  },
  activated() {
    if (this.$route.query.serviceNo) {
      sessionStorage.setItem('tab_sn', this.$route.query.serviceNo);
      this.session_sn = this.$route.query.serviceNo;
    }
    if (!this.$route.query) {
      this.session_sn = sessionStorage.getItem('tab_sn');
    }
    this.getTableData();
  },
  methods: {
    // TODO: 测试接口
    /**
     * 视频补录
     * @param row
     * @param str
     */
    blVideo(row, str) {
      // eslint-disable-next-line no-param-reassign
      row.strbol = false;
      const id = row.CARD_NO;
      const FILE_CREATE_TIME = this.formatDate(
        new Date().getTime(),
        'yyyy-MM-dd hh:mm:ss',
      );
      const dateN = FILE_CREATE_TIME.split(' '); // 年月日
      // 视频文件名=No+身份证号码+年月日时分秒
      const ip = $.busitrans.getMacIp();
      const spip = ip.split('#=#');
      if (str === 'sta') {
        strname = `No${id[0]}${dateN[0].split('-').join('')}${dateN[1]
          .split(':')
          .join('')}`;
        stadt = new Date();
        $.busitrans.startBatchRecord('169.254.0.1', '9101', strname, 0);
      } else if (str === 'end') {
        enddt = new Date();
        // eslint-disable-next-line no-param-reassign
        row.strbol = true;
        const ss = (Date.parse(this.fmtdate(enddt)) - Date.parse(this.fmtdate(stadt)))
          / 1000;
        /**
         * 结束录制
         */
        try {
          const endstr = $.busitrans.endBatchRecord(1);
          if (String(endstr) === '0') {
            const params = {
              data: {
                videoid: row.ID,
                ip: spip[2],
                serialNo: row.SERIAL_NO !== undefined ? row.SERIAL_NO : '',
                videoname: strname,
                startrec: this.fmtdate(stadt),
                endrec: this.fmtdate(enddt),
                videotype: 'mp4',
                ss,
              },
            };
            this.updateOrInsertVideo(params);
          }
        } catch (e) {
          this.$_throw(e);
        }
      }
    },
    // printV(fil6) {
    //   $.busitrans.WebPrint(fil6, 1); //打印凭证  1代表打印一次
    // },
    updateOrInsertVideo(params) {
      return this.$_post(this.$API.videoSupplement, params).then((res) => {
        this.$_yh_alert(res.data.success);
      });
    },
    getType(val) {
      const statusMap = {
        1: '产品认购',
        2: '部分支取',
        3: '全部支取',
      };
      return statusMap[val] || '';
    },
    getStatusType(v) {
      const STATUS_TYPE = {
        1: '认购成功',
        2: '支取成功',
      };
      return STATUS_TYPE[v] || v;
    },

    readVideo(videoId) {
      const parames = {
        data: {
          videoId,
        },
      };
      return this.$_post(this.$API.videoBrowse, parames).then((res) => {
        console.log(res.data.serviceVideo, '调阅数据');
        const videodata = res.data.serviceVideo;
        const { ip } = videodata;
        let port = '8282'; // 默认
        let filePath = '';
        let url = '';
        if (String(videodata.filestatus) === '2') {
          // 视频已上传
          filePath = videodata.filepath;
          port = res.data.ftpNingxPort;
        } else {
          // 视频未上传
          filePath = videodata.videoname;
          port = res.data.DviceIdPort;
        }
        url = `http://${ip}:${port}/${filePath}.${videodata.videotype}`;
        if (String($.busitrans.tryPort(ip, port)) === '0') {
          // 测试ip端口是否能通
          $.busitrans.runExe(`${res.data.potPlayA} ${url}`);
        } else {
          this.$_yh_alert('ip或端口不通!');
        }
      });
    },
    // 获取表格数据
    getTableData() {
      if (this.radio) {
        this.radio = '';
      }
      const parames = {
        pageMessage: {
          pageSize: this.pageSize,
          pageNo: this.currentPage,
        },
        data: {
          // serviceNo: this.dataRow.custServiceNo
          serviceNo: this.session_sn,
        },
      };
      return this.$_post(this.$API.serviceDetailListQuery, parames).then(
        (res) => {
          this.tableData = res.data.list;
          this.sumCount = res.sumCount;
        },
      );
    },
    // 获取打印凭证所需内容
    getVoucher(scope) {
      this.$confirm('确定要打印该交易凭证吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
      }).then(() => {
        const parames = {
          data: {
            bankSerialNo: scope.row.bankSerialNo,
          },
        };
        return this.$_post(this.$API.serviceVoucherInfo, parames).then((res) => {
          $.busitrans.webPrint(res.data.voucherDataNeeded, 1); // 打印凭证  1代表打印一次

          this.$message.success('打印成功！');
        });
      });

      // this.$confirm(`确定要打印该交易凭证吗？`, `提示`, {
      //   confirmButtonText: `确认`,
      //   cancelButtonText: `取消`,
      //   closeOnClickModal: false
      // })
      //   .then(() => {
      //     const parames = {
      //       data: {
      //         bankSerialNo: scope.row.bankSerialNo
      //       }
      //     };
      //     return this.$_post(this.$API.serviceVoucherInfo, parames).then(
      //       res => {
      //         $.busitrans.WebPrint(res.data.voucherDataNeeded, 1); // 打印凭证  1代表打印一次
      //         this.$message.success("打印成功！");
      //       }
      //     );
      //   })
      //   .catch(() => {
      //     this.$message.error("操作失败，请重试");
      //     // alert("操作失败，请重试");
      //   });
    },
  },
  filters: {
    hideLast(val) {
      if (val == null) {
        return '';
      }
      const lastX = '*'.repeat(val.length - 8);
      const tttf = val.replace(
        /^(\d{4})\d+(\d{4})$/,
        ($, $1, $2) => $1 + lastX + $2,
      );
      return tttf;
    },
  },
};
</script>
<style scoped lang="scss">
.disable {
  margin-top: 10px;
}
</style>
